import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class HomeGuard implements CanActivate {
  constructor(
    public environmentService: EnvironmentService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const result = new BehaviorSubject(true);

    this.environmentService
      .getInstanceDetails()
      .pipe(
        map((details: any) => {
          if (/ai-detection/.test(details?.scaffoldType)) {
            this.router.navigate(["/ai-detection-report"]);
            result.next(true);
          } else {
            result.next(true);
          }
        })
      )
      .subscribe();
    return result;
  }
}
